module.exports = __webpack_public_path__ + "img/fondo-naranja.00c33b02.jpg";